module.exports = __webpack_public_path__ + "img/legend.b43a7721.png";